import { Injectable } from '@angular/core';
import {ConfigurationDataService} from '../configuration-data.service';
import {SharedDataService} from '../shared-data.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import {LocationSearch} from './location-search';

@Injectable()
export class LocationSearchService {

  headers = new HttpHeaders({
      'Content-Type': 'application/json'
  });

  constructor(public http: HttpClient, private config : ConfigurationDataService, private shared: SharedDataService) {
  }

  /**
   * List all locationSearchs which belong to loggedin user.
   */
  public list() {
    console.log(JSON.stringify(this.shared.getTokenAuthData()));
    return this.http.post(this.config.locationSearchURL+"list", JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public save(locationSearch : LocationSearch) {
    console.log('Push locationSearch to insert method of service.');
    locationSearch.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(locationSearch));
    return this.http.post(this.config.locationSearchURL+"new", JSON.stringify(locationSearch), {headers: this.headers});
  }

  public update(locationSearch : LocationSearch) {
    console.log('Push locationSearch to update method of service.');
    locationSearch.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(locationSearch));
    return this.http.put(this.config.locationSearchURL+"id/"+locationSearch.id, JSON.stringify(locationSearch), {headers: this.headers});
  }

  public qryLocationSearch(id : number) {
    return this.http.post(this.config.locationSearchURL+"id/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public delete(id : number) {
    console.log('Delete locationSearch '+ id);
    return this.http.post(this.config.locationSearchURL+"del/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }
}



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/location/location-search.service.ts